import { useContextState } from "../../../../../../../../../../hooks/theme"


const useStyles = () => {
    const { colors } = useContextState()
    return {
        containerSearchInput: {
            marginBottom: '20px',
            display: 'flex',
            justifyContent: 'end'
        },
        containerProvider: {
            display: 'flex',
            gap: '5%',
            flexWrap: 'wrap',
            height: '35vh',
            overflow: 'auto',
            scrollbarWidth: 'none'
        },
        containerRadio: {
            backgroundColor: colors.color39,
            color: colors.color9,
            display: 'flex',
            '& .MuiTypography-root': {
                textAlign: 'start',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
            },
            alignItems: 'center',
            padding: 1,
            '& span': {
                fontWeight: 'bold'
            },
            width: '30%',
            maxHeight: '64px'
        },
        wdth: {
            width: '300px'
        },
    }
}

export { useStyles }
